import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant.js';
import FJVoiceItemContainer from '../../../FJTextToSpeech/FJTextToSpeechRight/container/FJVoiceItemContainer.jsx';
import FJCreateVoiceCloningContainer from '../../../FJVoiceCloning/container/FJCreateVoiceCloningContainer.jsx';
import { useSelector } from 'react-redux';
const FJClone = props => {
    const { voiceCloneList, onUse } = props;
    const createCloneStatus = useSelector(state => state.voiceCloning.createCloneStatus);

    return (
        <>
            {createCloneStatus === FJConstant.HISTORY_LIST ? (
                voiceCloneList.map(item => {
                    return (
                        <FJVoiceItemContainer
                            key={item.id}
                            info={item}
                            fromType={FJConstant.CLONE_BY_SELF}
                            onUse={onUse}
                        />
                    );
                })
            ) : (
                <FJCreateVoiceCloningContainer isInModal={true} />
            )}
        </>
    );
};
FJClone.propTypes = {
    voiceCloneList: PropTypes.array,
    onUse: PropTypes.func,
};
export default FJClone;
